import { Injectable, } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, Router, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { ProductsDataService } from './products.data.service';
import { SnackbarService } from '../../../core';


@Injectable()
export class ProductPageResolver implements Resolve<boolean> {
  constructor(
    private router: Router,
    public dataService: ProductsDataService,
    public snackBar: SnackbarService
  ) {}

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.dataService.getById(route.params['id'])
        .pipe(
          catchError((err) => {
            this.snackBar.info('Problem z tym SKU!');
            return of();
          }),
        );
  }
}